import {useState, useEffect} from "react";
import CountUp from 'react-countup';
import {API_URL} from '../../config';

const ChiffresAgence = () => {

    const [chiffres, setChiffres] = useState([]);
    useEffect(() => {
        fetch(`${API_URL}/stats`)
            .then((res) => res.json())
            .then((data) => setChiffres(data.stats || []));
    }, []);

    if(chiffres.length < 1) return <div className="loader-ville"><p>Chargement ...</p></div>

    return(
        <div className="chiffres px-8 py-16">
            <h2 className="min-[320px]:text-36 xl:text-title-49 font-bold">Pourquoi travailler ensemble ?</h2>
            <div className="chiffres-chiffre min-[320px]:grid-cols-1 grid xl:grid-cols-3 py-8">
                {chiffres.map((stat) => (
                    <div key={stat.id} className="flex flex-col justify-center">
                        <p><CountUp enableScrollSpy={true} end={parseInt(stat.value)} suffix={stat.value.replace(/[0-9]/g, '')}/></p>
                        <p>{stat.label}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ChiffresAgence